import { Card, Pagination } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
const PaginationMobile = ({ pagination, totalPages, onPageChange, }) => {
    const { t } = useTranslation();
    return (<Card>
            <div className="pb-4 text-gray-500 text-sm">
                {t('financing.pagination.showing')}
                <strong className="font-semibold text-gray-900">{` ${(pagination.pageIndex - 1) * pagination.pageSize + 1}-${pagination.pageIndex * pagination.pageSize} `}</strong>
                {t('financing.pagination.of')}{' '}
                <strong className="font-semibold text-gray-900">{pagination.total}</strong>
            </div>
            <Pagination onPageChange={onPageChange} currentPage={pagination.pageIndex} totalPages={totalPages}/>
        </Card>);
};
export default PaginationMobile;
